import { availabilitySchema } from '@/components/clubs/upsert-club/validations';
import { z } from 'zod';
import { Sport } from './sports.model';

export enum CLUB_STATUS {
  ENABLED = 'ENABLED',
  IN_PROGRESS = 'IN_PROGRESS',
  DISABLED = 'DISABLED',
}

export const CLUB_STATUS_LABELS: Record<CLUB_STATUS, string> = {
  [CLUB_STATUS.ENABLED]: 'Habilitado',
  [CLUB_STATUS.IN_PROGRESS]: 'En progreso',
  [CLUB_STATUS.DISABLED]: 'Deshabilitado',
};

export const CLUB_STATUS_COLORS: Record<CLUB_STATUS, string> = {
  [CLUB_STATUS.ENABLED]: 'bg-green-500',
  [CLUB_STATUS.IN_PROGRESS]: 'bg-yellow-500',
  [CLUB_STATUS.DISABLED]: 'bg-red-500',
};

export type Availability = z.infer<typeof availabilitySchema>;

export interface ClubAddress {
  id?: string;
  zipCode: string;
  street: string;
  fullCoordinates: string;
  latitude: number;
  longitude: number;
  state: string;
  city: string;
  country: {
    isoCode: string;
    name: string;
    phonePrefix: string;
  };
  timezone: string;
}

export interface Currency {
  isoCode: string;
  name: string;
}

export interface Price {
  value: number;
  currency: Currency;
}

export interface Court {
  id?: string;
  name: string;
  surface: string;
  wallType?: string;
  sport: Sport;
  clubId: string;
  price: Price;
  hasRoof: boolean;
}

export interface Manager {
  email: string;
  username: string;
  name: string;
}

export interface Instructor {
  email: string;
  username: string;
  name: string;
}

export type Club = {
  id: string;
  name: string;
  email: string;
  cuit: string;
  bannerUrl: string | null;
  status: CLUB_STATUS;
  address: ClubAddress;
  cellphone?: string;
  instagramLink?: string;
  facebookLink?: string;
  courts: Court[];
  availability: Availability;
  managers: Manager[];
  instructors: Instructor[];
};

export enum OwnershipType {
  OWNED = 'owned',
  MANAGED = 'managed',
}
